import { render, staticRenderFns } from "./SkipToResultsButton.vue?vue&type=template&id=7849a33e"
import script from "./SkipToResultsButton.vue?vue&type=script&lang=js"
export * from "./SkipToResultsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports